import React from 'react';
import PropTypes from 'prop-types';

import StatusBar from './StatusBar.jsx';

const propTypes = {
    visible: PropTypes.bool,
    frameWidth: PropTypes.number.isRequired,
    onSceneChange: PropTypes.func.isRequired,
};

const defaultProps = {
    visible: true,
    animationLength: 0.5,
};

function Header(props) {
    const {
        visible,
        onSceneChange,
        frameWidth,
    } = props;

    const style = {
        width: frameWidth,
        left: '50%',
        marginLeft: `-${frameWidth / 2}`,
        opacity: visible ? 1 : 0,
    };

    return (
        <div className="header" style={style}>
            <div className="status">
                <StatusBar onSceneChange={onSceneChange} />
            </div>
        </div>
    );
}

Header.propTypes = propTypes;
Header.defaultProps = defaultProps;

module.exports = Header;



// WEBPACK FOOTER //
// ./js/components/partials/Header.jsx